import EventEmmiter from 'lib/helpers/EventEmmiter';
import E3MeasurementPanel from "./panel";
import E3Plan3D from 'lib/e3plan-3d/e3plan-3d';

const cloneDeep = require('lodash/cloneDeep');

export default class Measurement extends EventEmmiter {
    config = null;
    container = null;
    e3plan_json = null;
    viewer = null;

    constructor({config, e3plan_json, translate, container, viewer}) {
        super();

        this.config = config;
        this.container = container;
        this.e3plan_json = e3plan_json;
        this.viewer = viewer;
        this.translate = translate;
    }

    init = async () => {
        if(this._panel) {
            this.destroy();
            return ;
        }

        this._panel = new E3MeasurementPanel(this.container, {translate: this.translate});
        await this._initE3Plan3DMeasurementMode();

        this._panel.on('add', () => {
            const {measurementTool} = this._e3Plan3D;
            measurementTool.closePolyline();
        })

        this._panel.on('close', () => {
            this.destroy();
        })
    
        this._panel.on('remove', () => {
            const {measurementTool} = this._e3Plan3D;
            measurementTool.removeShapes();
        })

        this._panel.on('set.unit', (e) => {
            const {measurementTool} = this._e3Plan3D;
            measurementTool.setUnit(e);
        })

        this.viewer.on('scenechange', () => {
            this.destroy();
        });
    }

    _initE3Plan3DMeasurementMode = async () => {
        const preview =  this._generateMeasurementPreview();
        if(!preview) return ;

        this._createContainer();
        let {offsetWidth: width, offsetHeight: height} = this.e3plan3DMeasurementContainer;
        
        this.viewer.canSendAction();

        this._e3Plan3D = new E3Plan3D(this.e3plan3DMeasurementContainer, this._generateMeasurementPreview(), {
            width,
            height,
            measurementMode: true
        });

        this._e3Plan3D.on('scene.get.current', this.onE3Plan3DSceneGetCurrentBound);

        await this._e3Plan3D.init(this.config.editable);
        
        this.viewer.on('animate', () => {
            if(this._e3Plan3D) this._e3Plan3D.setCameraPosition();
        })

        this._e3Plan3D.on('on.mouse.move', (event) => {
            this._fireEvent('on.mouse.move', event);
        })

        this._e3Plan3D.on('on.mouse.down', (event) => {
            this._fireEvent('on.mouse.down', event);
        })

        this._e3Plan3D.on('on.mouse.up', (event) => {
            this._fireEvent('on.mouse.up', event);
        })

        this._e3Plan3D.on('measurementTool.add.point', ({count, type, drawingLine}) => {
            if(!this._panel) return ;

            switch(type) {
                case 'start':
                    this._stageButton(1);
                    break;
                case 'end':
                    this._stageButton(1);
                    break;
                case 'onAddPoint':
                    if(count < 2) return ;
                    
                    this._stageButton(2);
                    break;
                default:
            }
        });

        this._e3Plan3D.initHiddenPreview();
    }

    _stageButton(number) {
        switch (number) {
            case 1:
                this._panel.toggleButton('add', 'add');
                this._panel.toggleButton('close', 'remove');
                this._panel.toggleButton('remove', 'add');
                this._panel.toggleLabel("remove");
            break;
            case 2:
                this._panel.toggleButton('add', 'remove');
                this._panel.toggleButton('close', 'add');
                this._panel.toggleButton('remove', 'remove');
                this._panel.toggleLabel("add");
            break;
        }
    }

    _createContainer() {
        this.e3plan3DMeasurementContainer = document.createElement('div');
        this.e3plan3DMeasurementContainer.classList.add('e3-viewer-3dplan-measurement');
        this.container.appendChild(this.e3plan3DMeasurementContainer);
    }

    _generateMeasurementPreview = () => {
        if(!this.e3plan_json || !this.e3plan_json.preview) return ;

        let preview = cloneDeep(this.e3plan_json.preview);
        let e3PlanPreview = null;

        const sceneID = this.viewer.getScene();

        previewLayerLoop: for(let i in preview.layers) {
            const areas = preview.layers[i].areas;
            for(let id in areas) {
                if(sceneID === areas[id].properties.scene.id){
                    preview.layers[i].areas = {
                        [id]: areas[id]
                    }
                    preview.layers = {
                        [i]: preview.layers[i]
                    }
                    e3PlanPreview = preview;
                    break previewLayerLoop;
                }
            }
        }

        return e3PlanPreview;
    }

    destroy(){
        if(!this._panel) return ;

        this._panel.hide();
        this._panel.destroy();
        this._panel = null;

        this._e3Plan3D.off('scene.get.current', this.onE3Plan3DSceneGetCurrentBound);
        this._e3Plan3D.measurementTool.destroy();
        this._e3Plan3D.destroy();
        this.container.removeChild(this.e3plan3DMeasurementContainer);
        this._e3Plan3D = null;

        this._fireEvent('destroy');
    }
}



